"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryByCpSnKeywords = exports.manufactureList = exports.updateStatus = exports.syqjQueryByCondition = exports.domainExport = exports.queryByCondition = exports.getDomainBySN = exports.searchDeviceSN = exports.updateJQStatus = exports.searchSnByKeywords = exports.searchDeviceList = exports.searchDevice = exports.searchAllNodeInfo = exports.searchNodeInfo = exports.getNodesEnum = exports.getBaseInfo = exports.searchSN = void 0;
const index_1 = __importDefault(require("../utils/request/index"));
//SN码或桩二维码模糊查询
const searchSN = (snKeyword) => {
    return (0, index_1.default)("/process/snKeyword", {
        method: "GET",
        params: {
            snKeyword,
        },
    });
};
exports.searchSN = searchSN;
//根据SN码或桩二维码查询基础信息
const getBaseInfo = (sn) => {
    return (0, index_1.default)("/process/baseInfo/" + sn, {
        method: "GET",
    });
};
exports.getBaseInfo = getBaseInfo;
//查询所有节点枚举
const getNodesEnum = () => {
    return (0, index_1.default)("/process/nodes", {
        method: "GET",
    });
};
exports.getNodesEnum = getNodesEnum;
//查询节点信息
const searchNodeInfo = (sn, type) => {
    return (0, index_1.default)("/process/partInfo/" + sn, {
        method: "GET",
        params: {
            type,
        },
    });
};
exports.searchNodeInfo = searchNodeInfo;
//查询所有节点信息
const searchAllNodeInfo = (sn, type) => {
    return (0, index_1.default)("/process/partInfo/all/" + sn, {
        method: "GET",
        params: {
            type,
        },
    });
};
exports.searchAllNodeInfo = searchAllNodeInfo;
//查询溯源器件数据
const searchDevice = (sn) => {
    return (0, index_1.default)("/syqj/queryBySn", {
        method: "GET",
        params: {
            sn,
        },
    });
};
exports.searchDevice = searchDevice;
// 查询器件列表
const searchDeviceList = (params) => {
    return (0, index_1.default)("/syqj/queryByQjList", {
        method: "GET",
        params,
    });
};
exports.searchDeviceList = searchDeviceList;
// 查询器件列表
const searchSnByKeywords = (params) => {
    return (0, index_1.default)("/syqj/queryByQjSnKeywords", {
        method: "GET",
        params,
    });
};
exports.searchSnByKeywords = searchSnByKeywords;
// 标记损坏器件
const updateJQStatus = (data) => {
    return (0, index_1.default)("/syqj/updateStatus", {
        method: "POST",
        data,
    });
};
exports.updateJQStatus = updateJQStatus;
//模糊查询溯源器件SN码
const searchDeviceSN = (keywords) => {
    return (0, index_1.default)("/syqj/querySn", {
        method: "GET",
        params: {
            keywords,
        },
    });
};
exports.searchDeviceSN = searchDeviceSN;
//获取销售领状态
const getDomainBySN = (sn) => {
    return (0, index_1.default)("/domain/saleList", {
        method: "GET",
        params: {
            sn,
        },
    });
};
exports.getDomainBySN = getDomainBySN;
//桩产品高级查询
const queryByCondition = (params) => {
    return (0, index_1.default)("/domain/queryByCondition", {
        method: "GET",
        params,
    });
};
exports.queryByCondition = queryByCondition;
//导出充电桩产品数据
const domainExport = (chanpinsnma) => {
    return (0, index_1.default)("/domain/export", {
        method: "GET",
        params: {
            chanpinsnma,
        },
    });
};
exports.domainExport = domainExport;
//溯源器件高级查询
const syqjQueryByCondition = (params) => {
    return (0, index_1.default)("/syqj/queryByCondition", {
        method: "GET",
        params,
    });
};
exports.syqjQueryByCondition = syqjQueryByCondition;
//标记坏件
const updateStatus = (data) => {
    return (0, index_1.default)("/syqj/updateStatus", {
        method: "POST",
        data,
    });
};
exports.updateStatus = updateStatus;
//请求充电桩产品字段
const manufactureList = (params) => {
    return (0, index_1.default)("/domain/manufactureList", {
        method: "GET",
        params,
    });
};
exports.manufactureList = manufactureList;
// 查询成品sn码列表
const queryByCpSnKeywords = (params) => {
    return (0, index_1.default)("/syqj/queryByCpSnKeywords", {
        method: "GET",
        params,
    });
};
exports.queryByCpSnKeywords = queryByCpSnKeywords;
